// @flow
import React, { Component } from "react";
import { GlobalProvider } from "../common/GlobalContext";
import trim from "lodash/trim";

import TipsContainer from "./TipsContainer";
import TipsHeadline from "./TipsHeadline";
import Links from "./Links";
import Buying from "./Buying";
import Moving from "./Moving";
import Mistakes from "./Mistakes";
import Selling from "./Selling";

type $Props = {
  classes: Object,
  theme: Object,
  path: string,
};

class Tips extends Component<$Props> {
  renderHeadline = () => {
    const { path } = this.props;
    const trimmedPath = trim(path, "/");
    let headline;

    switch (trimmedPath) {
      case "tips":
        headline = "Moving Tips";
        break;
      case "tips/moving":
        headline = "Moving Tips";
        break;
      case "tips/buying":
        headline = "Home Buying Tips";
        break;
      case "tips/selling":
        headline = "Home Selling Tips";
        break;
      case "tips/mistakes":
        headline = "Mistakes Sellers Make";
        break;

      default:
        break;
    }
    return headline;
  };

  renderContent = () => {
    const { path } = this.props;
    const trimmedPath = trim(path, "/");

    if (trimmedPath === "tips" || trimmedPath === "tips/moving") {
      return <Moving />;
    } else if (trimmedPath === "tips/buying") {
      return <Buying {...this.props} />;
    } else if (trimmedPath === "tips/selling") {
      return <Selling />;
    } else if (trimmedPath === "tips/mistakes") {
      return <Mistakes />;
    }
  };

  render() {
    const { theme } = this.props;
    const { path } = this.props;
    const trimmedPath = trim(path, "/");
    const headline = this.renderHeadline();
    return (
      <GlobalProvider theme={theme}>
        <TipsContainer>
          <Links page={trimmedPath} />
          <TipsHeadline headline={headline} />
          {this.renderContent()}
        </TipsContainer>
      </GlobalProvider>
    );
  }
}

export default Tips;
